const copyToclipboard = (content) => {
    const textarea = document.createElement("textarea")
    textarea.value = content
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, 99999); // 对于移动设备
    document.execCommand('copy');
    document.body.removeChild(textarea);
}

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    // window.Eurus.loadedScript.add(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);

            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };

                document.head.appendChild(script);
            }

            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                } else {
                    requestAnimationFrame(initScript);
                }
            } else {
                initScript();
            }
        };

        let autoloadScript;
        if (Shopify.designMode) {
            loadScript();
        } else {
            const wait = window.innerWidth > 767 ? 2000 : 5000;
            events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
            autoloadScript = setTimeout(() => {
                loadScript();
            }, wait);
        }
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
}